import { connect } from 'react-redux';
import { compose } from 'recompose';

import EquimentTable from './EquipmentTable';
import { openEquipmentModal } from '../actions';

import { queryEquipmentGQL } from '../graphql';

const mapStateToProps = (state) => {
  return {
    showEquipmentModal: state.equipmentList.showEquipmentModal,
  };
};

const mapDispatchToProps = {
  openEquipmentModal,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  queryEquipmentGQL,
  withRedux,
);

export default enhance(EquimentTable);
